/**
 * @qcintl/i18n-middleware
 *
 * 多语言中间件包
 * 提供 Express 中间件和 Next.js _app.js 辅助函数
 */

const { createI18nMiddleware } = require('./middleware');
const { processI18nData, withTimeout, isValidUrl } = require('./app-helper');
const { getUrlCache, setUrlCache, clearCache, getCacheStats } = require('./cache');
const { toCmsLang, extractLangFromPath, isSupportedLocale, SUPPORTED_LOCALES } = require('./lang-mapper');
const { CACHE_CONFIG, TIMEOUT_CONFIG, LANG_MAP, ROUTE_ID_MANIFEST, getManifest } = require('./constants');

module.exports = {
  // 中间件
  createI18nMiddleware,

  // _app.js 辅助函数
  processI18nData,
  withTimeout,
  isValidUrl,

  // 缓存工具
  getUrlCache,
  setUrlCache,
  clearCache,
  getCacheStats,

  // 语言映射
  toCmsLang,
  extractLangFromPath,
  isSupportedLocale,

  // 常量
  CACHE_CONFIG,
  TIMEOUT_CONFIG,
  LANG_MAP,
  SUPPORTED_LOCALES,
  ROUTE_ID_MANIFEST,

  // 工具函数
  getManifest,
};
